"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormikSchemaInput = void 0;
var react_1 = __importDefault(require("react"));
var context_1 = require("./context");
var input_1 = require("./input");
/**
 * Render a SchemaInput and wire it up with Formik which will handle passing the state down and managing
 * validation of the fields.
 */
function FormikSchemaInput(_a) {
    var name = _a.name, accountUuid = _a.accountUuid, schema = _a.schema;
    return (react_1.default.createElement(context_1.SchemaInputContext.Provider, { value: { schema: schema, accountUuid: accountUuid } },
        react_1.default.createElement(input_1.SchemaInput, { name: name, schema: schema })));
}
exports.FormikSchemaInput = FormikSchemaInput;
